import React, { useState, useMemo } from "react";
import './Shop.css';
import { useCraftStore, usePlayerStore } from "../../store/store";
import { Attribute, Information, Modifiers, Requirements, ShopItem, SocketItem } from "./Shop";
import DraggableModal from '../Modal/DraggableModal';

function Craft({ sendMessage }) {
    const [selectedItem, setSelectedItem] = useState(null);
    const [selectedFilter, setSelectedFilter] = useState('all');

    const gold = usePlayerStore((state) => state.gold);
    const shopList = useCraftStore((state) => state.craftList.list);
    const shopId = useCraftStore((state) => state.craftList.id);
    const setShowCraft = useCraftStore((state) => state.setShowCraft);
    const shopInfo = useCraftStore((state) => state.craftInfo);

    const filterList = (filter) => {
        setSelectedFilter(filter);
    };

    const closeCraft = () => {
        setShowCraft(false);
    }

    const filteredShopList = useMemo(() => {
        return shopList?.filter((e) => {
            if (selectedFilter === 'all') return true;
            return e.type2 === selectedFilter;
        });
    }, [selectedFilter, shopList]);


    function getItemInfo(item, itemId, index, cost, amount) {
        sendMessage('316' + shopId + ';craft info ' + item + ";" + itemId);
        setSelectedItem({ item, itemId, index, cost, amount });
    }

    function buyItem() {
        if (selectedItem) {
            sendMessage('316' + shopId + ";craft buy " + selectedItem.item + ";" + selectedItem.itemId);
        }
    }

    function CraftRequirements() {

        return (
            <>
                <div className="craft-req">
                    <div className="stats">
                        <div className="requirements">
                            <h3>Craft Requirements</h3>
                            {shopInfo.craftReq?.map((r, i) => <li key={i} className={r.meetsRequirement === true ? 'green' : 'red'}><Attribute name={r.name} value={r.val} /></li>)}
                        </div>
                    </div>
                </div>
            </>
        )
    }


    return (
        <DraggableModal modalId="craft" onClose={closeCraft}>
            <div className="modal-content" style={{ width: '900px' }}>
                <div className="tmodal-header">
                    <span className="close" onClick={closeCraft}>&times;</span>
                    <h2>Craft</h2>
                </div>
                <div className="modal-body" style={{ width: '100%', padding: '2px 5px' }}>
                    <div className="shop" style={{ height: '100%' }} >
                        <div>
                            <ul className="shop-list">
                                {filteredShopList?.map((e, i) => <ShopItem key={e.itemId} item={e} itemInfo={getItemInfo} index={i} selected={selectedItem?.itemId} />)}
                            </ul>
                            <select className="shop-filter" onChange={(e) => filterList(e.currentTarget.value)}>
                                <option value="all">All</option>
                                <optgroup label="Armours">
                                    <option value="HEAD">Head</option>
                                    <option value="NECK">Neck</option>
                                    <option value="BODY">Body</option>
                                    <option value="HANDS">Hands</option>
                                    <option value="FEET">Feet</option>
                                    <option value="WRIST">Wrist</option>
                                    <option value="FINGER">Finger</option>
                                    <option value="OFFHAND">Offhand</option>
                                    <option value="Shield">Shield</option>
                                </optgroup>
                                <optgroup label="Weapons">
                                    <option value="SWORD">Sword</option>
                                    <option value="DAGGER">Dagger</option>
                                    <option value="STAFF">Staff</option>
                                    <option value="MACE">Mace</option>
                                    <option value="HAMMER">Hammer</option>
                                </optgroup>
                                <option value="Other">Other</option>
                            </select>
                        </div>
                        <div className="shop-info">
                            <p className="ability-points">Available Gold (<span className="available-gold-amount">{gold.toLocaleString()}</span>)</p>

                            <div className="info-header">
                                <p>Information</p>
                            </div>
                            {shopInfo &&
                                <>
                                    <div className="info-desc">
                                        <Information shopInfo={shopInfo} />
                                        <p className="description">{shopInfo.description}</p>
                                        <div className="stats">
                                            <Requirements reqs={shopInfo.requirements} />
                                            <Modifiers mods={shopInfo.modifiers} uniMods={shopInfo.uniModifiers} />
                                        </div>
                                    </div>
                                    {shopInfo.maxSockets > 0 && <SocketItem shopInfo={shopInfo} />}
                                    <CraftRequirements />
                                </>
                            }
                            <div className="bottom">
                                <button className="ts-button" onClick={e => buyItem()}>Craft</button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal-footer">
                    <button className="ts-close" onClick={closeCraft}>Close</button>
                </div>
            </div>
        </DraggableModal>
    );
}




export default Craft;